export default `
  mutation createBCObject($workflowId: String!, $input: CreateBCObjectInput!) {
    createBCObject(workflowId: $workflowId, input: $input) {
      id
      boundedContextId
      filepath
      prompt
      contents
      draftContents
      tags
    }
  }
`
